import template from "./bSelectMdpId.html";
import SelectMdpId from '../SelectMdpId/SelectMdpId';

export function bSelectMdpIdDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: bSelectMdpIdController,
    controllerAs: 'bSelectMdpId',
    bindToController: true,
    scope: {
      state: "=",
      options: "=",
      searchFn: "&",
      value: "=",
      setClientFromMdp: "&",
      disabled: "=?",
      required: "=?"
    },
    transclude: true
  };

  return directive;
}

class bSelectMdpIdController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
    this.SelectMdpId = SelectMdpId;

    this.$onInit = () => {
      this.selectProps = {
        options: this.options,
        defaultValue: this.value,
        isSearchable: true,
        loadOptions: (value) => this.searchFn()(value),
        setClientFromMdp: (client) => this.setClientFromMdp()(client),
        required: this.required
      };
    };
  }
}
